module.exports = __webpack_public_path__ + "static/media/profile_placeholder_6.baa124c7.svg";